export default {
  HOME: "/",
  SIGN_IN: "/signin",
  PRODUCT_LIST: "/product/all",
  PRODUCT_SINGLE: "/product/:productId",
  CART: "/cart",
  ORDER_PLACED: "/order/placed",
  PROFILE: "/profile",
};
